/* istanbul ignore file */
import { createRoot } from 'react-dom/client'

import { i18n } from '@reveni-io/reveni-ui'
import { enTranslations as enReveniUITranslations } from '@reveni-io/reveni-ui'
import { frTranslations as frReveniUITranslations } from '@reveni-io/reveni-ui'
import { deTranslations as deReveniUITranslations } from '@reveni-io/reveni-ui'
import { ptTranslations as ptReveniUITranslations } from '@reveni-io/reveni-ui'
import { itTranslations as itReveniUITranslations } from '@reveni-io/reveni-ui'
import { nlTranslations as nlReveniUITranslations } from '@reveni-io/reveni-ui'
import { koTranslations as koReveniUITranslations } from '@reveni-io/reveni-ui'

import deTranslations from './i18n/translations/de'
import enTranslations from './i18n/translations/en'
import frTranslations from './i18n/translations/fr'
import itTranslations from './i18n/translations/it'
import koTranslations from './i18n/translations/ko'
import nlTranslations from './i18n/translations/nl'
import ptTranslations from './i18n/translations/pt'
import App from './App'
import { initSentry } from './helpers'

import '@reveni-io/reveni-ui/styles.css'
import './index.css'

import './axios.config'

export const i18nInstance = i18n({
  en: { translation: { ...enReveniUITranslations, ...enTranslations } },
  fr: { translation: { ...frReveniUITranslations, ...frTranslations } },
  de: { translation: { ...deReveniUITranslations, ...deTranslations } },
  pt: { translation: { ...ptReveniUITranslations, ...ptTranslations } },
  it: { translation: { ...itReveniUITranslations, ...itTranslations } },
  nl: { translation: { ...nlReveniUITranslations, ...nlTranslations } },
  ko: { translation: { ...koReveniUITranslations, ...koTranslations } },
})

const root = createRoot(document.getElementById('root'))
initSentry()
root.render(<App />)
